class URLValidator {
  static async isUrlMissing(url) {
    try {
      const response = await fetch(url, {
        method: "HEAD",
        signal: AbortSignal.timeout(8000),
      });
      return !response.redirected && (response.status === 404 || response.status === 410);
    } catch {
      return false;
    }
  }

  static async isUrlValid(url) {
    return !(await this.isUrlMissing(url));
  }

  static async validateUrls(siblings) {
    const validationPromises = siblings.map(async (sibling) => {
      const isValid = await this.isUrlValid(sibling.handle);
      return { sibling, isValid };
    });

    const results = await Promise.all(validationPromises);
    const validSiblings = results
      .filter((result) => result.isValid)
      .map((result) => result.sibling);
    return validSiblings;
  }

  static renderValidSiblings(validSiblings) {
    const container = document.getElementById("siblings-container");
    // Products without a colour selector render no sibling container.
    if (!container) return;
    const activeSibling = document.querySelector(".sibling__active");
    const localeElement = document.querySelector("[data-current-locale]");
    const isUS = localeElement
      ? localeElement.getAttribute("data-current-locale") === "us"
      : false;

    // Clear the container before rendering
    container.innerHTML = "";

    if (validSiblings.length === 0) {
      container.innerHTML = "";
      return;
    }

    container.appendChild(activeSibling);

    validSiblings.forEach((sibling) => {
      const link = document.createElement("a");
      // Get current locale and clean up path
      const pathParts = window.location.pathname.split("/").filter(Boolean);
      // const currentLocale = pathParts[0]?.length === 2 ? pathParts[0] : '';

      // Clean up handle by removing any trailing or leading slashes
      // const cleanHandle = sibling.handle.replace(/^\/+|\/+$/g, '');
      let currentLocale = "";
      if (isUS) {
        currentLocale = "en-us";
      } else {
        currentLocale = pathParts[0]?.length === 2 ? pathParts[0] : "";
      }

      const cleanHandle = sibling.handle.replace(/^\/+|\/+$/g, "");

      // Construct URL based on locale
      link.href = currentLocale
        ? `/${currentLocale}/products/${cleanHandle}`
        : `/products/${cleanHandle}`;

      const img = document.createElement("img");
      img.src = sibling.images[0];
      img.alt = sibling.title;
      img.loading = "lazy";

      const thumbnail = document.createElement("sibling-thumbnail");
      thumbnail.setAttribute("data-load-thumbnail", "");
      thumbnail.dataset.title = sibling.title;
      thumbnail.appendChild(img);
      link.appendChild(thumbnail);
      container.appendChild(link);
    });
  }

  static async init(siblings) {
    if (!Array.isArray(siblings) || !document.getElementById("siblings-container")) return;
    const validSiblings = await this.validateUrls(siblings);
    this.renderValidSiblings(validSiblings);
  }
}
